const ORCH_BASE_URL = 'https://hmorch.xyz-app.com';
// const ORCH_BASE_URL = 'http://127.0.0.1:8001';

export default ORCH_BASE_URL;
